export default {"src":"/_next/static/media/sauna.4565e100.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};